<template>
  <div class="nav-buttons d-flex justify-space-around mb-5">
    <OnexButton
      v-for="preference in orderedPreferencesList"
      variant="outlined"
      color="primary"
      class="bg-white"
      :height="'28px'"
      :key="preference.name"
      :href="!isPreview ? preference?.url : undefined"
      target="_blank"
      >{{ preference.name }}</OnexButton
    >
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { LandingPages } from '@/interfaces/PegaAgent';
import { Translations } from '@/i18n/models';
import { OnexButton } from '@primerica/onex-ui-lib';

export default defineComponent({
  components: {
    OnexButton,
  },
  props: {
    preferences: {
      type: [] as PropType<LandingPages[]>,
      required: true,
    },
    isPreview: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      Translations,
      landingPageTexts: [
        this.$t(Translations.yourFinancialGuide),
        this.$t(Translations.whatWeOffer),
        this.$t(Translations.ourBusinessOppurtunity),
      ],
    };
  },
  computed: {
    preferencesList(): LandingPages[] {
      if (!this.preferences.length) return [];
      return this.preferences
        .filter(
          (pref: LandingPages) => !!pref.url && !!pref.name && !pref.name.includes('RepWebsite')
        )
        .map((pref: LandingPages) => ({
          url: pref.url,
          name: this.decipherLandingPage(pref.name),
        }));
    },
    orderedPreferencesList(): LandingPages[] {
      const tempArray = [] as LandingPages[];
      this.landingPageTexts.forEach((text) => {
        const prefMatch = this.preferencesList.find((pref: LandingPages) => text === pref.name);
        if (prefMatch) tempArray.push(prefMatch);
      });
      return tempArray;
    },
  },
  methods: {
    decipherLandingPage(page: string) {
      if (page.includes('Opportunity')) return this.landingPageTexts[2];
      else if (page.includes('Client')) return this.landingPageTexts[1];
      return this.landingPageTexts[0];
    },
  },
});
</script>

<style scoped>
.nav-buttons :deep(.v-btn) {
  flex: 0 1 auto;
}
</style>
